/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Favorite_RemoveInputs */

const en_us2_exercise_personal_favorite_remove = /** @type {(inputs: Exercise_Personal_Favorite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from favourites`)
};

const pt_br2_exercise_personal_favorite_remove = /** @type {(inputs: Exercise_Personal_Favorite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar dos favoritos`)
};

const es_419_exercise_personal_favorite_remove = /** @type {(inputs: Exercise_Personal_Favorite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar de favoritos`)
};

const pt_pt2_exercise_personal_favorite_remove = /** @type {(inputs: Exercise_Personal_Favorite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar dos favoritos`)
};

const fr_fr2_exercise_personal_favorite_remove = /** @type {(inputs: Exercise_Personal_Favorite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer des favoris`)
};

const de_de2_exercise_personal_favorite_remove = /** @type {(inputs: Exercise_Personal_Favorite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Favoriten entfernen`)
};

const it_it2_exercise_personal_favorite_remove = /** @type {(inputs: Exercise_Personal_Favorite_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi dai preferiti`)
};

/**
* | output |
* | --- |
* | "Remove from favourites" |
*
* @param {Exercise_Personal_Favorite_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_favorite_remove = /** @type {((inputs?: Exercise_Personal_Favorite_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Favorite_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_favorite_remove(inputs)
	if (locale === "es-419") return es_419_exercise_personal_favorite_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_favorite_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_favorite_remove(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_favorite_remove(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_favorite_remove(inputs)
	return en_us2_exercise_personal_favorite_remove(inputs)
});
export { exercise_personal_favorite_remove as "exercise-personal.favorite_remove" }